export class CustomerOfferList {
    private params: any = {currentPage: 1};

    activate(params) {                
        this.params.Id = params.Id
    }
}